import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { refresh } from '../../services/auth.service';
import Spinner from '../../components/layout/Spinner';
import FadeIn from '../../utils/fadein';
import { FaEllipsisV, FaTimes } from 'react-icons/fa';
import { getPointActivity, createPointActivity, updatePointActivity, getPointBonusCodes, createPointBonusCode, updatePointBonusCode, getPointCompanyBonuses, createPointCompanyBonus,
  getSellerCompanies, updatePointCompanyBonus, createPointUserActivity,
  getPointUserBonuses
 } from '../../utils/api/admin';
 import { adminSearchUsers } from '../../utils/api';
import './PointActivity.css';
import { set } from 'date-fns';
import ScrollToTop from '../../components/layout/ScrollToTop';

function PointBonusUser() {
  const [loaded, setLoaded] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [pageBreakdown, setPageBreakdown] = useState([]);
  const [data, setData] = useState([]);
  const [showSaveBanner, setShowSaveBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [pointsEarned, setPointsEarned] = useState('');
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [editName, setEditName] = useState('');
  const [editDescription, setEditDescription] = useState('');
  const [editCode, setEditCode] = useState('');
  const [editPointsEarned, setEditPointsEarned] = useState('');
  const [editSelectedId, setEditSelectedId] = useState(null);
  const [costPerCredit, setCostPerCredit] = useState(.25);
  const [totalPoints, setTotalPoints] = useState(0);
  const [pointActivity, setPointActivity] = useState([]);
  const [code, setCode] = useState('');
  const [selectedActivityId, setSelectedActivityId] = useState(null);
  const [editSelectedActivityId, setEditSelectedActivityId] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [editCompanyId, setEditCompanyId] = useState(null);
  const [sellerCompanies, setSellerCompanies] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [editStartDate, setEditStartDate] = useState('');
  const [editEndDate, setEditEndDate] = useState('');
  const [userId, setUserId] = useState(null);
  const [editUserId, setEditUserId] = useState(null);
  const [query, setQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [showResults, setShowResults] = useState(false);  
  const [isAddingBonus, setIsAddingBonus] = useState(false);
  const imageUrl = process.env.REACT_APP_IMAGE_URL;
  const baseImageUrl = process.env.REACT_APP_BASE_IMAGE_URL;
  const screenshotUrl = process.env.REACT_APP_BASE_IMAGE_URL + 'companyscreenshots/';

  async function loadData(){
    let res = await getPointUserBonuses();

    if (res.success){
      setData(res.data);
      setLoaded(true);
    }
  }

  useEffect(() => {
    async function fetchActivity(){
      let res = await getPointActivity();

      if (res.success){
        setPointActivity(res.data);
      }
    }

    async function loadSellerCompanies(){
      let res = await getSellerCompanies();

      if (res.success){
        setSellerCompanies(res.data);
      }
    }

    async function loadData(){
      let res = await getPointUserBonuses();

      if (res.success){
        setData(res.data);
        setLoaded(true);
      }
    }

    loadSellerCompanies();
    fetchActivity();
    loadData();
  }, []);

  async function handleCreate(){
    setIsAddingBonus(true);
    let res = await createPointUserActivity(userId, selectedActivityId);

    if (res.success){
      loadData();

      setName('');
      setCode('');
      setPointsEarned('');
    }
    setIsAddingBonus(false);
  }

  function loadSaveBanner(){
    setShowSaveBanner(true);
    const timer = setTimeout(() => {
      setShowSaveBanner(false);
    }, 3000);
    return () => clearTimeout(timer);
  }

  async function handleEdit(id, item){
    setSelectedId(id);
    setEditName(item.name);
    setEditDescription(item.description);
    setEditCode(item.code);
    setEditPointsEarned(item.points_earned);
    setEditSelectedActivityId(item.point_activity_id);
    setEditStartDate(item.start_date);
    setEditEndDate(item.end_date);
    setEditCompanyId(item.company_id);
    setShowEdit(true);
  }

  async function handleUpdate(){
    let res = await updatePointCompanyBonus(selectedId, editCompanyId, editSelectedActivityId, 'Active', editStartDate, editEndDate);

    if (res.success){
      setShowEdit(false);
      loadData();
    }

    else{
      alert("Update failed");
    }
  }

  async function handleSearch(){
    setShowResults(true);
    if (query == ''){
      setSearchResults([]);
      return;
    }

    let res = await adminSearchUsers(query);

    if (res.success){
      setSearchResults(res.data);
    }
  }

  return (
    <>
      <ScrollToTop />
      <Helmet>
        <title>LeadrPro - Discover new software</title>
      </Helmet>

      <h1>Point Bonus for User</h1>

      <p className='mt-10 mb-10'>
        <strong>Point Bonus Companies allow you to reward users with points for specific actions.</strong>
      </p>

      <div className='mt-10'>
        <span className='btn' onClick={() => setShowAdd(!showAdd)}>+ Add User Bonus</span>
      </div>

      {showAdd && (
      <div className='admindashboard__form'>
        <div>
          <label>Search User</label>
          <div className='flex items-center space-x-2'>
            <input type='text' className='input' value={query} onChange={(e) => setQuery(e.target.value)} />

            <button className='btn' onClick={() => handleSearch()}>Search</button>
          </div>
        </div>

        {showResults && searchResults.length > 0 && (
          <div className='mt-4' style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc', borderRadius: '8px', padding: '10px' }}>
            {searchResults.map((user) => (
              <div key={user.registered_user_id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', marginBottom: '8px', border: '1px solid #ddd', borderRadius: '6px', backgroundColor: '#f9f9f9' }}>
                <span>{user.registered_user_id}: {user.first_name} {user.last_name} - {user.company_name} - {user.email}</span>
                <button className='btn' onClick={() => {
                  setUserId(user.registered_user_id);
                  setSearchResults([]);
                  setQuery('');
                }}>Select</button>
              </div>
            ))}
          </div>
        )}

        {showResults && searchResults.length === 0 && (
          <div className='mt-4 text-gray-500'>No users found</div>
        )}

        <div>
          <label>User ID</label>
          <div>
            <input type='text' className='input' value={userId} onChange={(e) => setUserId(e.target.value)} />
          </div>
        </div>

        <div className='mt-10'>
          <label>Point Activity</label>

          <div>
            <select value={selectedActivityId} onChange={(e) => setSelectedActivityId(e.target.value)}>
              <option value=''>Select Activity</option>
              {pointActivity.filter(x => x.type == 'User bonus').map((activity) => (
                <option key={activity.point_activity_id} value={activity.point_activity_id}>
                  {activity.name} - {activity.points_earned} Points
                </option>
              ))}
            </select>
          </div>
        </div>

      
        <div className='mt-20'>
          <button className='btn' onClick={() => handleCreate()} disabled={isAddingBonus}>
            {isAddingBonus ? 'Adding...' : 'Add Bonus'}
          </button>
        </div>
      </div>
      )}

      {loaded===false && (
        <Spinner />
      )}

      {loaded && (
         <div>
          <table className='admindashboard__table table'>
            <tr>
              <th>Date</th>
              <th>Company</th>
              <th>User</th>
              <th>Points Earned</th>

            </tr>

            {data.map((item, index) => (
              <tr key={index}>
                <td>
                  {new Date(item.date_created).toLocaleDateString()}
                </td>
                <td>
                 {item.company_id} : {item.company_name}
                </td>

                <td>
                  {item.registered_user_id}: {item.first_name} {item.last_name}
                </td>

                <td>
                  <div>
                    {item.point_activity_name}
                  </div>
                  +{item.points_earned} points == {item.points_earned * .25} USD
                </td>
              </tr>
            ))}
          </table>
       </div>
      )}

    {showEdit && (
        <>
          <div className='overlay'></div>
          <div className='modal'>
            <div className='modal__close' onClick={() => setShowEdit(false)}>
              <FaTimes />
            </div>

            <h2 className='modal__h2'>Edit</h2>

            <div className='mt-10'>
             
            <div>
              <label>Company</label>

              <div>
                <select value={editCompanyId} onChange={(e) => setEditCompanyId(e.target.value)}>
                  <option value=''>Select Company</option>
                  {sellerCompanies.map((company) => (
                    <option key={company.company_id} value={company.company_id}>
                      {company.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

              <div>
                <label>Point Activity</label>
               <div>
                 <select value={editSelectedActivityId} onChange={(e) => setEditSelectedActivityId(e.target.value)}>
                  <option value=''>Select Activity</option>
                  {pointActivity.map((activity) => (
                    <option key={activity.point_activity_id} value={activity.point_activity_id}>
                      {activity.name}
                    </option>
                  ))}
                </select>
               </div>
              </div>

              <div>
                <label>Start Date</label>
                <input type='date' className='input' value={editStartDate} onChange={(e) => setEditStartDate(e.target.value)} />
              </div>

              <div>
                <label>End Date</label>
                <input type='date' className='input' value={editEndDate} onChange={(e) => setEditEndDate(e.target.value)} />
              </div>

              <div className='mt-20'>
                <button className='btn' onClick={() => handleUpdate()}>Update</button>
              </div>
            </div>
          </div>
        </>
      )}

      {showSaveBanner && (
        <FadeIn delay={150} duration={300}>
          <div className='profileinfo__saved-banner'>
            Profile updated successfully!
          </div>
        </FadeIn>
      )}
    </>
  );
}

export default PointBonusUser;